import React from "react";
import PropTypes from "prop-types";
import ProgressMilestones from "./ProgressMilestones";
import CustomButton from "../CustomButton";

const NetworkGrowthSummary = ({ stats, onImportMore, onInviteMore }) => {
  if (!stats) return null;

  return (
    <div className="grow-network-summary">
      <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
        <h4>Network Growth</h4>
        <div className="d-flex gap-2">
          <CustomButton
            text="Import More"
            backgroundColor="#3A6ED4"
            color="#fff"
            handleClick={onImportMore}
            additionalClass="mr-2"
          />
          <CustomButton
            text="Invite Contacts"
            backgroundColor="#fff"
            color="#3A6ED4"
            borderColor="#3A6ED4"
            handleClick={onInviteMore}
          />
        </div>
      </div>
      <div className="gn-stats-row">
        <div className="gn-stat">
          <div className="gn-stat-value">{stats.imported || 0}</div>
          <div className="gn-stat-label">Contacts imported</div>
        </div>
        <div className="gn-stat">
          <div className="gn-stat-value">{stats.invites_sent || 0}</div>
          <div className="gn-stat-label">Invites sent</div>
        </div>
        <div className="gn-stat">
          <div className="gn-stat-value">{stats.converted || 0}</div>
          <div className="gn-stat-label">Successful signups</div>
        </div>
        <div className="gn-stat">
          <div className="gn-stat-value">{stats.pending || 0}</div>
          <div className="gn-stat-label">Pending</div>
        </div>
      </div>
      <ProgressMilestones
        milestones={stats.milestones || []}
        currentMilestone={stats.current_milestone || 0}
        campaignActive={!!stats.campaign_active}
      />
    </div>
  );
};

NetworkGrowthSummary.propTypes = {
  stats: PropTypes.object,
  onImportMore: PropTypes.func,
  onInviteMore: PropTypes.func,
};

export default NetworkGrowthSummary;
